/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PointPromotionCampaign {
    angular.module("meevo.plugins.pointPromotionCampaign", []);
}